import { render, staticRenderFns } from "./microShopCombGoods.vue?vue&type=template&id=c3da8908&scoped=true&"
import script from "./microShopCombGoods.vue?vue&type=script&lang=js&"
export * from "./microShopCombGoods.vue?vue&type=script&lang=js&"
import style0 from "./microShopCombGoods.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./microShopCombGoods.vue?vue&type=style&index=1&id=c3da8908&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3da8908",
  null
  
)

component.options.__file = "microShopCombGoods.vue"
export default component.exports